import React, { useEffect } from "react";

export const LoginComplete = () => {
    useEffect(() => {
        // Extract the redirectUrl from query parameters
        const urlParams = new URLSearchParams(window.location.search);
        const redirectUrl = urlParams.get("redirectUrl");

        // Redirect to the original URL after a short delay to allow the component to render
        const timer: number = window.setTimeout(() => {
            if (redirectUrl) {
                // Decode the URL in case it was encoded
                const decodedUrl = decodeURIComponent(redirectUrl);
                window.location.href = decodedUrl;
            } else {
                // Fallback: redirect to root if no redirectUrl is provided
                window.location.href = "/";
            }
        }, 500);

        // Clean up the timer when component unmounts
        return () => {
            window.clearTimeout(timer);
        };
    }, []);

    return <p>Login complete. Redirecting you back...</p>;
};
